import API from '@/services/config/config.js'

export default {
    // Upload a file for a medication
    uploadMedicationFile(medicationId, fileType, file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileType', fileType);

        return API.post(`/medicationRegisters/${medicationId}/upload-file`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then(response => {
            return response.data
        })
    },

    // Download a file for a medication
    downloadMedicationFile(medicationId, fileType) {
        return API.get(`/medicationRegisters/${medicationId}/download-file?fileType=${fileType}`, {
            responseType: 'blob'
        }).then(response => {
            // Create blob link to download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            
            // Debug: Log all headers
            console.log('Response headers:', response.headers);
            
            // Extract filename from response headers
            // Try different header name variations
            const contentDisposition = response.headers['content-disposition'] || 
                                     response.headers['Content-Disposition'] ||
                                     response.headers['content-Disposition'];
            
            console.log('Content-Disposition header:', contentDisposition);
            
            let filename = 'download';
            if (contentDisposition) {
                // Try multiple regex patterns to extract filename
                let filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (!filenameMatch) {
                    filenameMatch = contentDisposition.match(/filename=([^;]+)/);
                }
                if (!filenameMatch) {
                    filenameMatch = contentDisposition.match(/filename=(.+)/);
                }
                
                if (filenameMatch) {
                    filename = filenameMatch[1].trim();
                    // Remove quotes if present
                    filename = filename.replace(/^["']|["']$/g, '');
                    console.log('Extracted filename:', filename);
                }
            }
            
            // Ensure filename has proper extension
            if (!filename.includes('.')) {
                const contentType = response.headers['content-type'] || response.headers['Content-Type'];
                if (contentType && contentType.includes('application/pdf')) {
                    filename += '.pdf';
                } else if (contentType && contentType.includes('text/plain')) {
                    filename += '.txt';
                } else if (contentType && contentType.includes('image/jpeg')) {
                    filename += '.jpg';
                } else if (contentType && contentType.includes('image/png')) {
                    filename += '.png';
                }
            }
            
            console.log('Final filename:', filename);
            
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            
            return response.data
        })
    },

    // Delete a file for a medication
    deleteMedicationFile(medicationId, fileType) {
        return API.delete(`/medicationRegisters/${medicationId}/delete-file?fileType=${fileType}`)
            .then(response => {
                return response.data
            })
    },

    // Get file URL for viewing (if file is accessible via static route)
    getFileUrl(medicationId, filePath) {
        if (!filePath) return null;
        // Assuming files are served from /uploads/medication-files/
        return `${API.defaults.baseURL}/uploads/${filePath}`;
    },

    // Get file info for display
    getFileInfo(filePath) {
        if (!filePath) return null;
        
        const fileName = filePath.split('/').pop();
        const fileExtension = fileName.split('.').pop().toLowerCase();
        
        let fileType = 'document';
        let icon = 'description';
        
        switch (fileExtension) {
            case 'pdf':
                fileType = 'PDF Document';
                icon = 'picture_as_pdf';
                break;
            case 'doc':
            case 'docx':
                fileType = 'Word Document';
                icon = 'description';
                break;
            case 'jpg':
            case 'jpeg':
            case 'png':
                fileType = 'Image';
                icon = 'image';
                break;
            case 'txt':
                fileType = 'Text Document';
                icon = 'text_snippet';
                break;
            default:
                fileType = 'Document';
                icon = 'description';
        }
        
        return {
            fileName,
            fileType,
            icon,
            extension: fileExtension
        };
    }
}
